import type { CopyKey } from "@/copy/copy";

/** The app's pages, in the prototype's (v45) tab order. `path` is relative to /app. */
export type NavItem = { key: string; path: string; label: CopyKey; icon: string; tab: boolean };

export const NAV: NavItem[] = [
  { key: "home", path: "", label: "nav.home", icon: "🏠", tab: true },
  { key: "actions", path: "actions", label: "nav.actions", icon: "✅", tab: true },
  { key: "cashflow", path: "cash-flow", label: "nav.cashflow", icon: "💵", tab: true },
  { key: "budget", path: "budget", label: "nav.budget", icon: "🧾", tab: true },
  { key: "assets", path: "assets", label: "nav.assets", icon: "🏦", tab: true },
  { key: "debt", path: "debt", label: "nav.debt", icon: "💳", tab: true },
  { key: "networth", path: "net-worth", label: "nav.networth", icon: "📈", tab: true },
  { key: "retirement", path: "retirement", label: "nav.retirement", icon: "🌴", tab: true },
  { key: "priorities", path: "priorities", label: "nav.priorities", icon: "🎯", tab: true },
  { key: "decisions", path: "decisions", label: "nav.decisions", icon: "🔀", tab: true },
  { key: "achievements", path: "achievements", label: "nav.history", icon: "🏅", tab: true },
  { key: "updatedata", path: "update-data", label: "nav.updatedata", icon: "✏️", tab: true },
  { key: "sharpen", path: "sharpen", label: "nav.sharpen", icon: "✨", tab: false },
  { key: "settings", path: "settings", label: "nav.settings", icon: "⚙", tab: false },
];

export const appPath = (path: string) => (path ? `/app/${path}` : "/app");

/** Mobile: four primary tabs plus More, in the order of v47's tools/build-mobile.py (Settings added). */
export const MOBILE_PRIMARY = ["home", "actions", "cashflow", "budget"];
export const MOBILE_MORE = [
  "assets",
  "debt",
  "networth",
  "retirement",
  "priorities",
  "decisions",
  "achievements",
  "updatedata",
  "sharpen",
  "settings",
];

/**
 * The page a path shows, by exact match ("/app/decisions" is the hub, "/app/decisions/expense" a
 * module and none). The dev gallery's `/dev/app/...` paths match too.
 */
export function navKeyForPath(pathname: string): string | undefined {
  const sub = pathname
    .replace(/^\/dev/, "")
    .replace(/^\/app\/?/, "")
    .replace(/\/$/, "");
  return NAV.find((n) => n.path === sub)?.key;
}
